export default {"src":"/_next/static/media/seb.dab7e083.svg","height":489,"width":208,"blurWidth":0,"blurHeight":0};